import { ThunkDispatch, createAsyncThunk } from "@reduxjs/toolkit";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
import { AnyAction, combineReducers } from "redux";

import attachmentReducer from "store/modules/attachment/reducer";
import authReducer from "store/modules/auth/reducers";
import customizationReducer from "store/modules/costumizations/reducer";
import globalConfigurationsReducer from "store/modules/globalConfiguration/reducer";
import loadingReducer from "store/modules/loading/reducer";
import mediaDevicesReducer from "store/modules/mediaDevices/reducer";
import permissionReducer from "store/modules/permission/reducer";
import playerReducer from "store/modules/playercontrol/reducer";
import policeUnitReducer from "store/modules/policeUnit/reducer";
import procedureReducer from "store/modules/procedure/reducer";
import profileReducer from "store/modules/profile/reducer";
import userProfileCreateReducer from "store/modules/profileCreate/reducer";
import screenStatusReducer from "store/modules/screenControl/reducer";
import userReducer from "store/modules/user/reducer";
import userCreateDistrict from "store/modules/userCreateUnit/reducer";
import customerCertificateReducer from "store/modules/customerCertificate/reducer";
import profilePermissionQueue from "./modules/profilePermissionQueue/reducer/reducer";
import audienceFilterReducer from "store/modules/audienceFilter/reducer";

export interface ThunkExtraArg {
  addToast: (toast: {
    type?: "success" | "error" | "warning";
    title: string;
    description?: string;
    timeLimitToast?: number;
  }) => void;
}

const rootReducer = combineReducers({
  auth: authReducer,
  loading: loadingReducer,
  attachment: attachmentReducer,
  user: userReducer,
  profile: profileReducer,
  permissions: permissionReducer,
  policeUnit: policeUnitReducer,
  player: playerReducer,
  userCreateDistrict: userCreateDistrict,
  userCreateProfile: userProfileCreateReducer,
  procedure: procedureReducer,
  screen: screenStatusReducer,
  configurations: globalConfigurationsReducer,
  customization: customizationReducer,
  mediaDevices: mediaDevicesReducer,
  customerCertificate: customerCertificateReducer,
  profilePermissionQueue,
  audienceFilter: audienceFilterReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = ThunkDispatch<RootState, ThunkExtraArg, AnyAction>;

export const useAppDispatch = useDispatch<AppDispatch>;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: RootState;
  extra: ThunkExtraArg;
}>();

export default rootReducer;
